import { useEffect, useState } from 'react';
import { getCustomerOrders } from '../../../../services/ozonRealization';

function rub(v) {
  const n = Number(v || 0);
  return `${n.toLocaleString('ru-RU', { maximumFractionDigits: 0 })} ₽`;
}

// ─────────────────────────────────────────────────────────────────────────────
// CustomerOrdersModal — standalone modal showing a customer's purchase history
// (repeat orders) inline, without navigating to "Повторные заказы". Reuses the
// same GET /ozon-realization/{account}/customers/{customer_id}/orders endpoint
// that "Повторные заказы → Клиенты" uses. Used from FBS "Что покупал".
// ─────────────────────────────────────────────────────────────────────────────
export default function CustomerOrdersModal({ accountId, customerId, request, onClose }) {
  const [orders, setOrders] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setOrders(null);
    setError(null);
    setLoading(true);
    (async () => {
      try {
        const d = await getCustomerOrders({ request, accountId, customerId });
        if (!cancelled) setOrders(d);
      } catch (e) {
        if (!cancelled) setError(String(e?.message || e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [request, accountId, customerId]);

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        style={{
          background: 'var(--surface, #fff)', borderRadius: 10, padding: 24,
          width: '100%', maxWidth: 720, maxHeight: '85vh', overflowY: 'auto',
          boxShadow: '0 8px 40px rgba(0,0,0,0.25)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>Что покупал {customerId}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>

        {loading && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-muted)', fontSize: 13 }}>
            <span className="spinner" aria-hidden="true" /> Загрузка заказов…
          </div>
        )}
        {error && <p style={{ color: '#e74c3c', fontSize: 13 }}>Ошибка: {error}</p>}

        {orders && (
          <>
            <p style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 0 }}>
              Всего заказов: <strong>{orders.total_postings ?? 0}</strong>
            </p>
            {(!orders.postings || orders.postings.length === 0) && (
              <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>
                У этого покупателя пока нет повторных заказов.
              </p>
            )}
            {(orders.postings || []).map((p) => (
              <div key={p.posting_number} style={{
                border: '1px solid var(--border, #ddd)', borderRadius: 8,
                padding: '10px 14px', marginBottom: 10,
              }}>
                <div style={{ fontWeight: 600, fontSize: 13 }}>
                  {p.posting_number}
                  {p.created_date && <span style={{ fontWeight: 400, color: 'var(--text-muted)', marginLeft: 8 }}>{p.created_date}</span>}
                </div>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>
                  Выручка: <strong>{rub(p.revenue)}</strong> · Реализация: <strong>{rub(p.realization)}</strong>
                </div>
                {(p.items || []).slice(0, 3).map((it, j) => (
                  <div key={j} style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 1 }}>
                    — {it.product_name || it.offer_id} ×{it.quantity}
                  </div>
                ))}
                {(p.items || []).length > 3 && (
                  <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>+ ещё {p.items.length - 3} позиций</div>
                )}
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
